import { usePathname } from "next/navigation";
import { useTranslation } from "../../../utils/hooks/useTranslation";
import { useCommonData } from "../CommonDataProvider";

type NavigationLinkConfig = { title: string; path: string; altPaths?: string[] };

export const useHeaderNavigationLinks = (): {
  isNavigationLinkSelected: (link: NavigationLinkConfig) => boolean;
  navigationLinks: NavigationLinkConfig[];
} => {
  const { headerFooterData } = useCommonData();
  const { t, lang } = useTranslation();
  const pathname = usePathname();

  // Make sure header navigation link is still marked as selected when a related alternative path is selected (e.g. both "/lister" and "/anbefalinger" marks the "anbefalinger" header navigation link)
  const isNavigationLinkSelected = (link: NavigationLinkConfig) => {
    if (pathname?.startsWith(`/${lang}${link.path}`)) return true;
    if (link.altPaths?.find((altPath) => pathname?.startsWith(`/${lang}${altPath}`))) return true;
    return false;
  };
  if (!headerFooterData) return { isNavigationLinkSelected, navigationLinks: [] };

  const hasRecommendations = !!headerFooterData.bookListCount || !!headerFooterData.recommendationCount;

  return {
    isNavigationLinkSelected,
    navigationLinks: [
      ...(hasRecommendations ? [{ path: "/lister", altPaths: ["/anbefalinger"], title: t("Anbefalinger") }] : []),
      ...(headerFooterData.eventsCount > 0 ? [{ path: "/arrangementer", title: t("Arrangementer") }] : []),
      ...(headerFooterData.digitalLibraryServiceCount > 0
        ? [{ path: "/digitalt-bibliotek", title: t("Digitalt bibliotek") }]
        : []),
      ...(headerFooterData.servicesCount > 0 ? [{ path: "/tjenester", title: t("Tjenester og tilbud") }] : []),
    ],
  };
};
